import EventEmitter from '../Utils/EventEmitter';
import Events from '../Utils/Events';
import Directions from '../Controls/Directions';
import Menu from './Menu';

export default class ItemDetailUI {
    constructor(menu) {
        // Picture focus
        this.pictureFocusDiv = document.querySelector('.picture-focus');
        this.detailButton = document.querySelector('.detail-button');
        this.backButton = document.querySelector('.back-button');

        // Picture detail
        this.pictureDetailDiv = document.querySelector('.picture-detail');
        this.pictureImage = document.querySelector('#picture');
        this.pictureCaption = document.querySelector('.caption');
        this.infoButton = document.querySelector('.info-button');
        this.closeButton = document.querySelector('.close-button');

        this.currentItem = null;
        this.eventEmitter = new EventEmitter();
        this.setupListeners(menu);
    }

    setupListeners(menu) {
        this.onBackFromItemClicked = () => {
            this.pictureFocusDiv.style.display = 'none';
            this.currentItem.removeFocus();
            this.currentItem = null;
        };
        this.onDetailButtonClicked = () => {
            this.pictureFocusDiv.style.display = 'none';
           // if (menu instanceof Menu) menu.menuDiv.style.display = 'none';
            //this.pictureImage.src = this.currentItem.sources[0];
            this.pictureDetailDiv.style.display = 'grid';
            this.pictureCaption.scrollTo(0, 0);
        };
        this.onInfoButtonClicked = () => {
            this.pictureCaption.classList.toggle('show-flex');
        };
        this.onCloseButtonClicked = () => {
            this.pictureDetailDiv.style.display = 'none';
            this.pictureFocusDiv.style.display = 'flex';
            if (menu instanceof Menu) menu.menuDiv.style.display = 'flex';
        };

        this.eventEmitter.on(Events.ITEM_HAS_FOCUS, this, (item) => {
            this.currentItem = item;
            this.pictureFocusDiv.style.display = 'flex';
        });
        this.backButton.addEventListener('click', this.onBackFromItemClicked, false);
        this.detailButton.addEventListener('click', this.onDetailButtonClicked, false);
        this.infoButton.addEventListener('click', this.onInfoButtonClicked, false);
        this.closeButton.addEventListener('click', this.onCloseButtonClicked, false);
    }

    destroy() {
        this.eventEmitter.off(Events.ITEM_HAS_FOCUS, this);
        this.backButton.removeEventListener('click', this.onBackFromItemClicked, false);
        this.detailButton.removeEventListener('click', this.onDetailButtonClicked, false);
        this.closeButton.removeEventListener('click', this.onCloseButtonClicked, false);
    }
}
